// extracted by mini-css-extract-plugin
export default {"image":"CardImageAdmin_image__Jxuaf","divButtons":"CardImageAdmin_divButtons__NhvM7","txtButtonG":"CardImageAdmin_txtButtonG__W-IoQ","txtButtonR":"CardImageAdmin_txtButtonR__mVg7i"};